export const DEFAULT_PAGE_SIZE_OPTIONS: number[] = [25, 50, 100, 150];

export const DEFAULT_PAGE_SIZE = 25;
